import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormGroupType } from '../../../../../../../core/models/form-group-type';
import { OrderStatus } from '../../../../../../../modules/application/orders/shared/constants/order-status';
import { OrderStatusFormModel } from '../models/order-status-form-model';

@Injectable({
    providedIn: 'root',
})
export class OrderStatusCellRendererFormService {
    getFormDefinition(): FormGroup<FormGroupType<OrderStatusFormModel>> {
        return new FormGroup<FormGroupType<OrderStatusFormModel>>({
            status: new FormControl<OrderStatus | null>(
                null,
                Validators.required,
            ),
        });
    }
}
